import {RouteDefinition} from "../../../routes"
import {BackgroundSettingsScreen} from "./BackgroundSettingsScreen"
import {CustomIconTheme} from "./CustomIconTheme"
import {CustomMenu} from "./CustomMenu"
import {ScreenEditScreen} from "./ScreenEditScreen"
export const CustomizationSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/custom-menu",
        component: CustomMenu
    },
    {
        routerLink: "/settings/custom-menu/customization",
        component: BackgroundSettingsScreen
    },
    {
        routerLink: "/settings/custom-menu/icon-theme",
        component: CustomIconTheme
    },
    {
        routerLink: "/settings/custom-menu/screen-set",
        component: ScreenEditScreen
    }
]
